module.exports = __webpack_public_path__ + "img/icon08.002f93f4.png";